import { useSuspenseQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { meQuery } from "../../session";
import styles from "../customers/customers.module.css";

/** A business's or partner's API tokens and webhooks, for whoever manages integrations. */
export function IntegrationLinks({ owner }: { owner: { business_id: string } | { partner_id: string } }): ReactNode {
  const { data: me } = useSuspenseQuery(meQuery);
  if (!me?.permissions.includes("integrations.manage")) return null;
  return (
    <p className={styles.actions}>
      <span className={styles.muted}>Their systems:</span>
      <Link to="/settings/api-tokens" search={{ ...owner, status: "all" }} className={styles.link}>
        API tokens
      </Link>
      <Link to="/settings/webhooks" search={owner} className={styles.link}>
        Webhooks
      </Link>
    </p>
  );
}
